"use client"

import { createContext, useContext, useMemo, type PropsWithChildren, type ReactNode } from "react"
import type { Message } from "./types"

export type ChatMessagePresentation = {
  formatAssistantText: (text: string, message: Message) => string
  renderAssistantText?: (text: string, message: Message) => ReactNode
  renderAssistantFooter: (message: Message) => ReactNode
}

const defaultPresentation: ChatMessagePresentation = {
  formatAssistantText: (text) => text,
  renderAssistantFooter: () => null,
}

const ChatMessagePresentationContext = createContext<ChatMessagePresentation>(defaultPresentation)

export function ChatMessagePresentationProvider({
  children,
  presentation,
}: PropsWithChildren<{ presentation: Partial<ChatMessagePresentation> }>) {
  const parentPresentation = useContext(ChatMessagePresentationContext)
  const value = useMemo<ChatMessagePresentation>(
    () => ({
      ...parentPresentation,
      ...presentation,
    }),
    [parentPresentation, presentation]
  )

  return (
    <ChatMessagePresentationContext.Provider value={value}>
      {children}
    </ChatMessagePresentationContext.Provider>
  )
}

export function useChatMessagePresentation(): ChatMessagePresentation {
  return useContext(ChatMessagePresentationContext)
}
